import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
    reports:{
        reportList:[],
        isLoading:false,
        hasError:false
    }
}

export const reportReducer = (state = initialState,action) => {
    const newState = {...state}
    switch(action.type){
        case actionTypes.GET_REPORT_FETCH_STARTED:
            return {
                ...newState,
                reports:{ ...newState.reports,isLoading:true,hasError:false}
            }
        case actionTypes.GET_REPORT_FETCH_SUCCESS:
            return {
                ...newState,
                reports:{ ...newState.reports, reportList:action.payload,isLoading:false,hasError:false}
            }
        case actionTypes.GET_REPORT_FETCH_FAILURE:
            return {
                ...newState,
                reports:{ ...newState.reports, reportList:action.payload,isLoading:false,hasError:true}
            }    
        default:
            return{ ...newState };    
    }
}